export default __webpack_public_path__ + "static/media/figure_korobu.cd5603d5.png";